<template>
    <section class="mb-3 mb-lg-4" id="paso-3">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2 class="text-uppercase mb-4">{{ $t('bases.subir_documentacion') }}</h2>
                </div>
                <div class="col-12">
                    <b-card-text v-if="!esRenovacion || manager.documentacion_obligatoria_bases">
                        <p style="font-size: 19px;">{{ $t('bases.nueva_inscripcion') }}</p>
                        <ul>
                            <li style="font-size: 19px;"><b>{{ $t('bases.dni_jugador') }}</b></li>
                            <li style="font-size: 19px;"><b>{{ $t('bases.dni_responsables') }}</b></li>
                        </ul>
                        <p style="font-size: 19px;">{{ $t('bases.peso_imagenes', {peso: maxFilesize}) }}</p>
                    </b-card-text>
                    <b-card-text v-else>
                        <h4>{{ $t('bases.imagenes_renovacion', {imagen: 'documentación' }) }}</h4>
                    </b-card-text>
                    <div v-if="localData?.documentos?.length > 0">
                        <hr/>
                        <h4 class="mt-2">{{ $t('bases.documentos_subidos') }}</h4>
                        <ul class="list-unstyled">
                            <template v-for="documento in localData.documentos">
                                <li class="h5" :key="documento.id">
                                    <a :href="documento.url" target="_blacnk" class="btn-link text-secondary"><i class="far fa-fw fa-image "></i> {{ documento.nombre }}</a>
                                    <button style="border: 0; background-color: white;" @click="showModal('borrar-' + documento.id)">&#10006;</button>
                                    <BorrarModalComponent
                                        :name="'borrar-' + documento.id"
                                        :title="'Borrar documento adjunto ' + documento.nombre"
                                        confirmButton="¿Está segur@ de borrar este documento?"
                                        v-on:close="() => closeModal()"
                                        v-on:confirm="() => borrarDocumento(documento.id)"
                                    />
                                </li>
                            </template>
                        </ul>
                    </div>
                    <Dropzone
                        v-if="url"
                        :url="url"
                        :maxFilesize="maxFilesize"
                        :maxFiles="10"
                        :acceptedFiles="'image/jpeg,image/png,image/gif,image/bmp,image/tiff,application/pdf,.pdf'"
                        :disabled="loading"
                        @success="vdropzone_success_handler"
                    />
                    <h4 style="font-size: 24px;" v-if="esRenovacion || !manager.documentacion_obligatoria_bases" class="mt-2 text-uppercase">{{ $t('bases.fotos_opcionales', {foto: 'documentación'}) }}</h4>
                    <div class="text-right mt-3">
                        <button type="button" @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button mr-2' : 'button effect-button mr-2'" id="volver-paso-2" :disabled="loading" >
                            <span>{{ $t('formularios.atras') }}</span>
                        </button>
                        <button @click="terminar" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" data-cy="terminar-paso-3" id="terminar-paso-3" :disabled="loading || desactivar">
                            <span>{{ $t('formularios.continuar') }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Dropzone from '@/components/common/Dropzone';
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";

    export default {
        props: ["base", "esMovil"],
        data() {
            return {
                formulario: null,
                url: this.config.API_BASE + "/f/upload/documento" + "?tipo=bases&id=" + this.base["dni"],
                maxFilesize: 20,
                loading: false,
                documentos_id: [],
                localData: { ...this.base }
            };
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            esRenovacion() {
                return window.location.href.indexOf("renovar") > -1;
            },
            desactivar() {
                if (this.manager.documentacion_obligatoria_bases) {
                    if (this.esRenovacion) {
                        if(!this.localData?.documentos?.length) {
                            return !this.documentos_id.length;
                        }
                    } else {
                        return !this.documentos_id.length;
                    }
                }

                return false;
            }
        },
        methods: {
            vdropzone_success_handler(file, response) {
                this.documentos_id.push(response.documento_id);
            },
            terminar() {
                this.loading = true;

                const documentos_id = this.documentos_id?.length ? this.documentos_id : (this.localData?.documentos || []).map(doc => doc.id);

                if (!documentos_id?.length) {
                    this.$emit('terminado', this.localData);
                    return;
                }

                const params = {
                    documentos_id,
                    session_id: this.localData.session_id,
                    filters: {}
                };

                this.$store.dispatch(this.config.getVuexAlias('front.bases.guardar-documentos'), params).then(res => {
                    this.$emit("terminado", this.localData);
                }).catch(err => {
                    console.error("Error al guardar los datos:", err);
                }).finally(() => {
                    this.loading = false;
                });
            },
            borrarDocumento(id) {
                this.localData?.documentos?.splice(this.localData?.documentos?.findIndex(function(i){
                    return i.id === id;
                }), 1);
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            volver() {
                this.$emit('volver');
            },
        },
        components: {
            Dropzone, BorrarModalComponent
        },
    };
</script>
